import React, { useState } from "react";
import { T } from "../../../traks";
import { Row, Col } from 'reactstrap';

export const PaymentMethod = ({ updateField }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("credit_card");
  
  const handlePaymentMethodSelection = (e) => {
    const method = e.target.value;
    setSelectedPaymentMethod(method);
    if (updateField) {
      updateField('selectedPaymentMethod', method);
    }
  };

  return (
    <Row className="mt-2 mb-2">
      <Col>
      <Row className="mb-2">
        <Col>
          <span className="ad_120_bold">
            <T>Payment method</T>
          </span>
        </Col>
      </Row>

        <Row>
          <Col>
            <div className="text-left">
              <label className="ad_custom_checkmark_container" style={{ paddingTop: "1px" }}>
                <input
                  type="radio"
                  name="payment_method"
                  value="credit_card"
                  checked={selectedPaymentMethod === "credit_card"}
                  onChange={handlePaymentMethodSelection}
                />
                <span className="ad_large_own_checkmark" />
              </label>
              <label htmlFor="payment_method_credit_card" className="d-inline">
                <span><T>Credit Card</T></span>
              </label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-left">
              <label className="ad_custom_checkmark_container" style={{ paddingTop: "1px" }}>
                <input
                  type="radio"
                  name="payment_method"
                  value="ean"
                  checked={selectedPaymentMethod === "ean"}
                  onChange={handlePaymentMethodSelection}
                />
                <span className="ad_large_own_checkmark" />
              </label>
              <label htmlFor="payment_method_ean" className="d-inline">
                <span><T>EAN</T></span>
              </label>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/PaymentMethod.js